import { supabase, handleSupabaseError } from '../lib/supabase'
import { callAdminMutation } from '../lib/adminClient'

export const organizationService = {
  // Get all organizations
  async getAll() {
    try {
      const { data, error } = await supabase
        .from('organizations')
        .select('*')
        .order('name')
      
      if (error) throw error
      return data || []
    } catch (error) {
      if (import.meta.env.DEV) console.error('Error fetching organizations:', error)
      return []
    }
  },

  // Get organization by ID
  async getById(id) {
    try {
      const { data, error } = await supabase
        .from('organizations')
        .select('*')
        .eq('id', id)
        .single()
      
      if (error) throw error
      return { data, error: null }
    } catch (error) {
      return { data: null, error: handleSupabaseError(error) }
    }
  },

  // Get organization for a user
  async getUserOrganization(userEmail) {
    try {
      const { data: user, error: userError } = await supabase
        .from('users')
        .select('organization_id')
        .eq('email', userEmail)
        .single()
      
      if (userError || !user?.organization_id) return null
      
      const { data, error } = await supabase
        .from('organizations')
        .select('*')
        .eq('id', user.organization_id)
        .single()
      
      if (error) throw error
      return data
    } catch (error) {
      if (import.meta.env.DEV) console.error('Error fetching user organization:', error)
      return null
    }
  },

  // Get users in organization
  async getOrganizationUsers(organizationId) {
    try {
      const { data, error } = await supabase
        .from('users')
        .select('*')
        .eq('organization_id', organizationId)
        .order('name')
      
      if (error) throw error
      return data || []
    } catch (error) {
      if (import.meta.env.DEV) console.error('Error fetching organization users:', error)
      return []
    }
  },

  // Update user's organization - SECURED via server-side admin verification
  async assignUserToOrganization(userEmail, organizationId) {
    try {
      const data = await callAdminMutation('user.assignToOrganization', {
        userEmail,
        organizationId
      })
      return { data, error: null }
    } catch (error) {
      return { data: null, error: handleSupabaseError(error) }
    }
  },

  // Update organization details - SECURED via server-side admin verification
  async update(organizationId, updates) {
    try {
      const data = await callAdminMutation('organization.update', {
        id: organizationId,
        ...updates
      })
      return { data, error: null }
    } catch (error) {
      return { data: null, error: handleSupabaseError(error) }
    }
  },

  // Create new organization - SECURED via server-side admin verification
  async create(organizationData) {
    try {
      const data = await callAdminMutation('organization.create', {
        name: organizationData.name,
        domain: organizationData.domain
      })
      return { data, error: null }
    } catch (error) {
      return { data: null, error: handleSupabaseError(error) }
    }
  }
}